import { useEffect } from "react";
import { Button } from "../../../../core/components/Button";
import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { ClipBoardIcon } from "../../../../core/icons/ClipBoard";
import { useLottie } from "lottie-react";
import animationLottery from "../../../../core/assets/lottery.json";

export const FinishTime = ({ handleResults }: { handleResults: () => void  }) => {
	const options = {
		animationData: animationLottery,
		loop: true,
	};
	const { View, setSpeed } = useLottie(options);
	const animationDuration = 4024;
	const desiredDuration = 2000;
	useEffect(() => {
		const speedMultiplier = animationDuration / desiredDuration;
		setSpeed(speedMultiplier);
	}, [setSpeed]);
	return (
		<>
			<TextComponent
				variant="h3"
				className="text-black text-center"
			>
				¡Tu sorteo ya ha sido publicado!
				<br /> Por favor, <strong>recarga la página</strong> o haz clic en <strong>'Ver Resultados'</strong>.
			</TextComponent>
			<Column className="w-80 lg:w-96 ">{View}</Column>
			<Button
				className="w-full font-bold"
				color="orange"
				onClick={handleResults}
				sizeLoading="w-5 h-5"
				secondary
			>
				<Row
					className="gap-1"
					crossAxisAlignment="center"
					mainAxisAlignment="center"
				>
					<ClipBoardIcon className="w-5 h-5" />
					<span>Ver resultados</span>
				</Row>
			</Button>
		</>
	);
};
